import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask, PrimaryButton, Dropdown, KeepAspectRatio } from '../../..';

import { WHITE, BLACK, ORANGE, ORANGE_LIGHT } from '../../../styles/shared/colors';
import './ShareVideoModal.scss';

const ShareVideoModal = ({ isVisible, onDecline, teams, recordTeamId, thumbnailUri, onApprove })=> {
  const [ selectedTeam, setSelectedTeam ] = useState(null);
  const displayedTeams = teams.filter(team => team._id !== recordTeamId);

  const handleAccept = ()=> {
    if (!selectedTeam) {
      return;
    };
    onAccept(selectedTeam);
  };

  const handleSelect = team => {
    setSelectedTeam(team);
  }

  return (
    <DarkScreenMask isVisible={isVisible}>
        <div className="share-video-modal">
          <span>With which team would you like to share this game</span>
          <Dropdown 
            items={displayedTeams}
            displayedProperty="name"
            onSelect={handleSelect}
          />
          <KeepAspectRatio adjustAcordingToWidth>
            <img className="share-video-modal__thumbnail" src={thumbnailUri} alt=""/>
          </KeepAspectRatio>
          <div className="share-video-modal__buttons">
            <PrimaryButton 
              background={BLACK} 
              color={WHITE} 
              showBorder
              onClick={onDecline}
            >
              DISCARD
            </PrimaryButton>
            <PrimaryButton
              background={selectedTeam ? ORANGE : ORANGE_LIGHT}
              color={WHITE}
              onClick={onApprove}
            >
              SAVE
            </PrimaryButton>
          </div>
        </div>
    </DarkScreenMask>
  );
};

ShareVideoModal.propTypes = {
  isVisible: PropTypes.bool, 
  onDecline: PropTypes.func, 
  onApprove: PropTypes.func, 
  recordTeamId: PropTypes.string, 
  teams: PropTypes.array, 
  thumbnailUri: PropTypes.string
};

ShareVideoModal.defaultProps = {
  isVisible: false, 
  onDecline: ()=>{}, 
  onApprove: ()=>{}, 
  recordTeamId: "", 
  teams: [], 
  thumbnailUri: ""
};

export default ShareVideoModal;